

module.exports = __webpack_require__.stylable.create(
    "suggestionfooter3611147190",
    {"classes":{"root":"suggestionfooter3611147190__root","icon":"suggestionfooter3611147190__icon","text":"suggestionfooter3611147190__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/SuggestionFooter/SuggestionFooter.st.css */ 620,
    null
);
